import { getMeta } from '../meta.js';
import { showMessageBox } from '../msgbox.jsx';
import xhr from '../xhr.js';

(() => {
    const elsewhereUri = getMeta('profile-elsewhere');
    if(typeof elsewhereUri !== 'string')
        return;

    const elsewhereTarget = document.querySelector('.js-profile-elsewhere');
    if(!(elsewhereTarget instanceof HTMLElement))
        return;

    let view, form;

    const edit = elsewhereTarget.querySelector('.js-edit');
    const save = elsewhereTarget.querySelector('.js-save');
    const cancel = elsewhereTarget.querySelector('.js-cancel');

    const removeForm = () => {
        save.type = 'button';
        save.removeAttribute('form');
        form.replaceWith(view);
        form = undefined;
        save.hidden = cancel.hidden = true;
        edit.hidden = false;
    };

    const submitForm = async ev => {
        ev.preventDefault();

        if(ev.target.dataset.disabled)
            return;
        ev.target.dataset.disabled = '1';

        try {
            for(let i = 0; i < ev.target.elements.length; ++i) {
                const element = ev.target.elements[i];
                element.dataset.disabled = element.disabled ? '1' : '';
                element.disabled = true;
            }

            const params = new URLSearchParams;
            for(let i = 0; i < ev.target.elements.length; ++i) {
                const element = ev.target.elements[i];
                if(element instanceof HTMLInputElement && element.type === 'text' && element.value !== element.dataset.initial)
                    params.set(`p${element.name}`, element.value);
            }

            if(params.size < 1) {
                removeForm();
                return;
            }

            const { status, body } = await xhr.patch(elsewhereUri, { authed: true, csrf: true, type: 'json' }, params);

            if(status === 200) {
                if(body.length < 1)
                    view = <div class="profile-elsewhere-notice"><em>Link to your profiles elsewhere!</em></div>
                else
                    view = <>{...body.map(entry => <div class="profile-elsewhere-entry">
                        <div class="profile-elsewhere-title">{entry.title}</div>
                        {(html => {
                            const value = <div class="profile-elsewhere-value" />;
                            value.insertAdjacentHTML('beforeend', entry.html);
                            return value;
                        })(entry.html)}
                    </div>)}</>;

                view = <div class="profile-elsewhere-list">{view}</div>;
                removeForm();
                return;
            }

            if(status === 400 && typeof body === 'object' && Array.isArray(body.format)) {
                for(let i = 0; i < ev.target.elements.length; ++i) {
                    const element = ev.target.elements[i];
                    if(body.format.includes(element.name)) {
                        element.setCustomValidity('This field isn\'t properly formatted!');
                        setTimeout(() => void element.reportValidity(), 0);
                        element.oninput = () => {
                            element.setCustomValidity('');
                            element.oninput = null;
                        };
                    }
                }
                return;
            }

            switch(status) {
            case 404: throw new Error('Profile not found.');
            case 403: throw new Error('You are not allowed to edit this elsewhere section.');
            case 400: throw new Error('One or more fields were not properly formatted.');
            default: throw new Error(`Received unexpected HTTP status code ${status}.`);
            }
        } catch(ex) {
            await showMessageBox(ex, 'Elsewhere');
        } finally {
            for(let i = 0; i < ev.target.elements.length; ++i) {
                const element = ev.target.elements[i];
                element.disabled = element.dataset.disabled !== '';
                delete element.dataset.disabled;
            }

            delete ev.target.dataset.disabled;
        }
    };

    edit.onclick = async () => {
        cancel.disabled = save.disabled = edit.disabled = true;
        try {
            const { status, body } = await xhr.get(elsewhereUri, { authed: true, csrf: true, type: 'json' });

            if(status !== 200) switch(status) {
            case 404: throw new Error('Profile not found.');
            case 403: throw new Error('You are not allowed to edit this elsewhere section.');
            default: throw new Error(`Received unexpected HTTP status code ${status}.`);
            }

            view ??= elsewhereTarget.querySelector('.js-content');
            view.replaceWith(form = <form class="profile-elsewhere-list" id="_elsewhere" onsubmit={submitForm}>
                {...body.map(entry => <label class="profile-elsewhere-entry">
                    <div class="profile-elsewhere-title">{entry.title}</div>
                    <input type="text" name={entry.name} class="input__text profile-elsewhere-input" value={entry.value ?? ''} data-initial={entry.value ?? ''} />
                </label>)}
            </form>);

            save.type = 'submit';
            save.setAttribute('form', form.id);

            save.hidden = cancel.hidden = false;
            edit.hidden = true;
        } catch(ex) {
            await showMessageBox(ex, 'Elsewhere');
        } finally {
            cancel.disabled = save.disabled = edit.disabled = false;
        }
    };

    cancel.onclick = async () => {
        cancel.disabled = save.disabled = edit.disabled = true;
        try {
            removeForm();
        } catch(ex) {
            await showMessageBox(ex, 'Elsewhere');
        } finally {
            cancel.disabled = save.disabled = edit.disabled = false;
        }
    };
})();
